import { put, select } from "redux-saga/effects";
import importer from "common/importer";
const ChatbotActions = importer("Stores/Chatbot/Actions");
const { getChatbotResponse } = importer("APIs/chatbot", null);

export default function* main({ inputText }) {
  try {
    yield put(ChatbotActions.getChatbotResponseLoading());
    const res = yield getChatbotResponse({ ...inputText });
    const data = res?.data;
    if (data && data.statusCode && data.statusCode === 500) {
      throw error(data);
    }
    yield put(ChatbotActions.getChatbotResponseSuccess(data));
  } catch (error) {
    yield put(
      ChatbotActions.getChatbotResponseFailure({ message: "Chatbot Broken" })
    );
  }
}
